const template = document.querySelector('.reservision-widget-template');

window.addEventListener(
    'CookiebotOnAccept', () => {
        const parent = template.parentNode;
        if (!parent) {
            return;
        }

        const clone = template.content.cloneNode(true);

        const widget = clone.querySelector('.reservision-widget-container').parentNode;

        if (widget) {
            parent.appendChild(widget);
        }
    }
);
